import React, { useState } from 'react';

import ModalComponent from "../../../../components/Modal";
import ReactHtmlParser from "react-html-parser";
import { firebaseFire as Libfirebase } from "../../../../helpers/firebase-config";
import ListStatus from "../../../../components/ListStatus";
import InputIcon from '../../../../gb-components/InputIcon';
import Input from '../../../../components/Input';
import ImageView from '../../../../gb-components/ImageView';
import { getLoggedInUser } from "../../../../helpers/authUtils";
import IconComment from '../../../../assets/svg/comments-alt.svg';
import moment from 'moment';
import './cardanamnese.scss';

const CardAnamnese = ({ comentario, refDesc, refComent, refType, refId, interacao, item, usuario, idPaciente, card, aba, pacienteId, idHistorico, profissional, exames, observacao, queixa, Hora, midias, especialidade, historico, refProfissional, DataCriacao, OpenModal, _setResponder }) => {

  const [dataRetorno, setDataRetorno] = useState('');
  const [openModal, setOpenModal] = useState(false);
  const [status, setStatus] = useState(null);

  const [profNome, setProfNome] = useState('');
  const [block, setBlock] = useState(false);

  const _setStatus = value => {


    // this.setState({ status: value, notifition: false, msg: "", nameclass: "" });

    if (dataRetorno) {
      Libfirebase.collection("paciente")
        .doc(idPaciente)
        .update({
          status: value,
          DataRetorno: moment(dataRetorno).format("DD-MM-YYYY")
        })
        .then(() => {
          console.log('sucesso')
          //   this.setState({
          //     openModal: false,
          //     notifition: true,
          //     msg: "Status alterado com sucesso!",
          //     nameclass: "alert-success"
          //   });
        })
        .catch(error => {
          console.log('erro')
          //   this.setState({
          //     openModal: false,
          //     status: null,
          //     notifition: true,
          //     msg: "Houve um erro ao salvar o status",
          //     nameclass: "alert-danger"
          //   });
        });
    } else {
      Libfirebase.collection("paciente")
        .doc(idPaciente)
        .update({ status: value })
        .then(() => {
          console.log('sucesso')
          //   this.setState({
          //     openModal: false,
          //     notifition: true,
          //     msg: "Status alterado com sucesso!",
          //     nameclass: "alert-success"
          //   });
        })
        .catch(error => {
          console.log('erro')
          //   this.setState({
          //     openModal: false,
          //     status: null,
          //     notifition: true,
          //     msg: "Houve um erro ao salvar o status",
          //     nameclass: "alert-danger"
          //   });
        });
    }
  };


  const renderComentario = () => {
    return (
      <div>
        {refDesc ? (
          <div >
            <a className="alert alert-warning " style={{ display: 'block', width: '100%' }} href={'#' + refId}>
              Em resposta á: {refDesc}
            </a>
          </div>
        ) : null}
        <div style={{ display: 'block' }}>
          {ReactHtmlParser(comentario)}
        </div>
      </div>
    )
  }

  const renderHistorico = () => {
    return (
      <div>
        {especialidade ? (
          <p className="gb-card-title">
            <strong>Especialidade:</strong> {ReactHtmlParser(especialidade)}
          </p>
        ) : null}

        {queixa ? (
          <div className="gb-card-title">
            <strong>Queixa:</strong> {ReactHtmlParser(queixa)}
          </div>
        ) : null}
        {historico ? (
          <div className="gb-card-title">
            <strong>Histórico:</strong> {ReactHtmlParser(historico)}
          </div>
        ) : null}
        {exames ? (
          <div className="gb-card-title">
            <strong>Exames:</strong> {ReactHtmlParser(exames)}
          </div>
        ) : null}
        {observacao ? (
          <div className="gb-card-title">
            <strong>Observação:</strong> {ReactHtmlParser(observacao)}
          </div>
        ) : null}

        <ModalComponent
          openModal={openModal}
          closeModal={() => setOpenModal(false)}
        >
          <h2>Deseja atualizar o status do histórico?</h2>
          <p>
            Apenas alterando o status que os outros profissionais saberão
            do seu comentário!
          </p>
          <ListStatus
            status={status}
            change={event => setStatus(event.target.value)}
          />
          {status === "Acompanhamento Ambulatorial" ||
            status === "Acompanhamento Pós Operatório" ? (
            <InputIcon>
              <Input
                placeholder="Data de Retorno"
                type="date"
                id="dataRetorno"
                value={dataRetorno}
                onChange={text => setDataRetorno(text)}
              />
            </InputIcon>
          ) : null}

          <div style={{ float: "right" }}>
            <button
              style={{ float: "left" }}
              onClick={() => _setStatus(status)}
              type="button"
              className="btn waves-effect waves-light btn-success"
            >
              Alterar Status
            </button>
            <button
              style={{ float: "left" }}
              onClick={() => setOpenModal(false)}
              type="button"
              className="btn waves-effect waves-light btn-danger"
            >
              Cancelar
            </button>
          </div>
        </ModalComponent>
      </div>
    )
  }

  return (
    <div className={getLoggedInUser().username === profissional ? "gb-card balao mb-3" : "gb-card balao2 mb-3"}>
      <div className={getLoggedInUser().username === profissional ? "gb-card-header profissional" : "gb-card-header"}>
        <p>{profissional ? profissional : profNome}{" "}{/* {Concluida ? (<p>{Concluida}</p>) : null} */}</p>
        <div style={{ textAlign: getLoggedInUser().username === profissional ? 'right' : null, }}>
          {DataCriacao ? (
            <span className="gb-card-header-hora">
              {" "}{DataCriacao.replace("-", "/").replace("-", "/")}{" "}{Hora ? Hora : ""}
            </span>
          ) : null}

        </div>
      </div>

      <div className="gb-card-body">
        {card == 'historico' ? renderHistorico() : renderComentario()}

        <ImageView midias={midias} />

      </div>

      <div className="gb-card-footer">
        {!block ? <div className="gb-card-footer-button" onClick={() => _setResponder()}>
          <img src={IconComment} height="16" />
          Comentar
        </div> : null}
      </div>

    </div>
  )
}

export default CardAnamnese;